import { render, staticRenderFns } from "./QScrollbar.vue?vue&type=template&id=dd9e24b2&"
import script from "./QScrollbar.vue?vue&type=script&lang=js&"
export * from "./QScrollbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports